import React, { useState, useEffect } from "react";
import { Users, MessageCircle, Brain, X, Clock,ChevronDown  } from 'lucide-react';
import {
  BarChart3,
  CheckCircle,
  XCircle,
  TrendingUp,
  Save,
} from "lucide-react";
import JSON5 from 'json5';
import IdeasPageHeader from "./IdeasPageHeader";

const formatDate = (dateString) => {
  // Handle empty or undefined values
  if (!dateString || dateString === "Unknown date") {
    return "";
  }

  // If it's already in mm/dd/yyyy format, return as-is
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    return dateString;
  }

  try {
    // Try parsing as ISO string first
    let date = new Date(dateString);
    
    // If that fails, try parsing as mm/dd/yyyy
    if (isNaN(date.getTime())) {
      const parts = dateString.split('/');
      if (parts.length === 3) {
        date = new Date(parts[2], parts[0] - 1, parts[1]);
      }
    }

    if (isNaN(date.getTime())) {
      console.warn('Invalid date:', dateString);
      return "";
    }

    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${month}/${day}/${year}`;
  } catch (e) {
    console.warn('Date formatting error:', e);
    return "";
  }
};
const ReviewProcessComponent = ({ selectedId, setSelectedIdeaId }) => {
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [selectedITPMIdea, setSelectedITPMIdea] = useState(null);
  const [activeTab, setActiveTab] = useState("ai-review-supervisor","ai-review-itpm");
  const [reviewComments, setReviewComments] = useState("");
  const [itpmReviewComments, setITPMReviewComments] = useState("");
  const [aiReviewData, setAiReviewData] = useState(null);
  const [itpmAiReviewData, setITPMAiReviewData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showClarifyBot, setShowClarifyBot] = useState(false);
  const [supervisorReviewData, setSupervisorReviewData] = useState(null);
  const [itpmReviewData, setITPMReviewData] = useState(null);
  const [pendingIds, setPendingIds] = useState([]);
  const [reviewDate, setReviewDate] = useState("Unknown date");
  const transformedData = {
  Id: selectedId, // Use selectedId if available
  title: "Data Quality Monitoring Platform - Carlos M.",
  submitter: "Carlos M.",
  date: reviewDate,
  priority: "high",
  description:
    "Establish continuous monitoring of key data sets to prevent errors. Deploy monitoring tools and configure alerts to detect and correct 90% of data issues proactively, improving data accuracy and reducing operational disruptions.",
  businessCase:
    "Current data quality issues cause operational disruptions and reduced accuracy. This platform will implement automated corrections and real-time data quality alerts, improving overall system reliability and data integrity.",
  alignment: 23,
  urgency: 26,
  value: 31,
};

const [questionResponses, setQuestionResponses] = useState(null);
const [showQuestionsModal, setShowQuestionsModal] = useState(false);




const fetchQuestionResponses = async (Id) => {
  try {
    setLoading(true);
    const response = await fetch("/api/guidance/get_question_response", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        uuid_id: `ID_${Id}` // Assuming your ID needs this format
      }),
    });
    
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    setQuestionResponses(data);
    setShowQuestionsModal(true);
  } catch (error) {
    console.error("Error fetching question responses:", error);
    setError("Failed to load question responses");
  } finally {
    setLoading(false);
  }
};
  // Helper function to safely parse JSON
  const safeJsonParse = (jsonString) => {
    try {
      return jsonString ? JSON.parse(jsonString) : null;
    } catch (e) {
      console.error("JSON parse error:", e);
      return null;
    }
  };
  // API call to update supervisor review
const updateSupervisorReview = async (Id, status, comment) => {
  try {
    const response = await fetch(`/api/review/supervisorreview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Id: Id,
        Status: status,
        Comment: comment
      })
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    console.log("Supervisor review update result:", result);
    return result;
  } catch (error) {
    console.error("Error updating supervisor review:", error);
    setError("Failed to update supervisor review");
    throw error;
  }
};

const fetchPendingIds = async () => {
  try {
    const response = await fetch('/api/idea/get_ideamanagement');
    if (!response.ok) throw new Error('Failed to fetch pending IDs');
    const data = await response.json();

    // Filter for pending status ideas and extract IDs and titles.
    //
    // Two bugs lived here and between them the dropdown was always empty:
    //   1. "ITPM Reveiw Status" is misspelled — get_ideamanagement returns
    //      "ITPM Review Status", so that clause could never match. (dashboard.py
    //      aliases the same column WITH the typo, which is how it survived.)
    //   2. The API returns lowercase 'pending'/'approved'; this compared against
    //      'Pending', so the first clause never matched either.
    // Compare case-insensitively and accept either spelling.
    const statusOf = (item, ...keys) => {
      for (const k of keys) {
        if (item[k] != null) return String(item[k]).trim().toLowerCase();
      }
      return '';
    };
    const pending = data.filter(item =>
      statusOf(item, 'Review Status') === 'pending' ||
      statusOf(item, 'ITPM Review Status', 'ITPM Reveiw Status') === 'pending'
    );

    // Map to id/title objects and remove duplicates based on ID
    const pendingWithTitles = pending.map(item => ({
      id: item.Id,
      title: item["Title & Sponsor"] || `Untitled (ID ${item.Id})` // Add fallback if title is missing
    }));

    // Remove duplicates by ID - keep only the first occurrence
    const uniquePending = pendingWithTitles.filter((item, index, self) =>
      index === self.findIndex((t) => t.id === item.id)
    );

    setPendingIds(uniquePending);

  } catch (error) {
    console.error('Error fetching pending IDs:', error);
    setError('Failed to load pending IDs');
  }
};
useEffect(() => {
  console.log('Pending IDs:', pendingIds); // Add this to see what's in the state
  fetchPendingIds();
}, []);  // API call to update ITPM review
const updateITPMReview = async (Id, status, comment) => {
  try {
    const response = await fetch(`/api/review/itpmreview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Id: Id,
        Status: status,
        Comment: comment
      })
    });

    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const result = await response.json();
    console.log("ITPM review update result:", result);
    return result;
  } catch (error) {
    console.error("Error updating ITPM review:", error);
    setError("Failed to update ITPM review");
    throw error;
  }
};


    // API call to get supervisor review data
const fetchSupervisorReviewData = async (Id) => {
  try {
    const response = await fetch(`/api/review/get_review_window_content?Id=${Id}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    
    // Transform the data to match your frontend expectations
    const transformedData = {
      Id: data.id,
      title: data.title,
      submitter: data.title.split('-').pop().trim(), // Extracts "Emily T." from the title
      date: reviewDate, // Or get from backend if available
      priority: "high", // You might need to get this from backend
      description: data.purpose,
      businessCase: "", // Add if available from backend
      alignment: data.alignment_score * 10, // Convert 1.4 to 14%
      urgency: data.urgency_score * 10, // Convert 2.7 to 27%
      value: data.value_score * 10 // Convert 1.7 to 17%
    };
    
    setSupervisorReviewData(transformedData);
    return transformedData;
  } catch (error) {
    console.error("Error fetching supervisor review:", error);
    setError("Failed to load supervisor review data");
    return null;
  }
};





// API call to get ITPM review data
const fetchITPMReviewData = async (Id) => {
  try {
    const response = await fetch(`/api/review/get_review_window_content?Id=${Id}`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    
    // Transform the data similar to supervisor review
    const transformedData = {
      Id: data.id,
      title: data.title,
      submitter: data.title.split('-').pop().trim(),
      date: reviewDate,
      priority: "medium",
      description: data.purpose,
      businessCase: "",
      alignment: data.alignment_score * 10,
      urgency: data.urgency_score * 10,
      value: data.value_score * 10
    };
    
    setITPMReviewData(transformedData);
    return transformedData;
  } catch (error) {
    console.error("Error fetching ITPM review:", error);
    setError("Failed to load ITPM review data");
    return null;
  }
};

  // API call to save draft
  const saveDraft = async (Id, comment) => {
    try {
      const response = await fetch("/api/review/savedraft", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id,
          Comment: comment,
        }),
      });
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      return safeJsonParse(text);
    } catch (error) {
      console.error("Error saving draft:", error);
      setError("Failed to save draft");
      throw error;
    }
  };

  // API call to get review window content
  const getReviewWindowContent = async (Id) => {
    try {
      const response = await fetch(
        `/api/review/get_review_window_content?Id=${Id}`
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      return safeJsonParse(text);
    } catch (error) {
      console.error("Error fetching review window content:", error);
      return null;
    }
  };

  // API call to get AI review data
  const getAIReview = async (Id) => {
    try {
      const response = await fetch(`/api/ai_review/get_ai_review?Id=${Id}`);
      console.log(response);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      return safeJsonParse(text);
    } catch (error) {
      console.error("Error fetching AI review data:", error);
      return null;
    }
  };

  // API call to get ITPM AI review data
  const getITPMAIReview = async (Id) => {
    try {
      const response = await fetch(`/api/ai_review/get_itpm_ai_review?Id=${Id}`);
      console.log(response);
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const text = await response.text();
      return safeJsonParse(text);
    } catch (error) {
      console.error("Error fetching ITPM AI review data:", error);
      return null;
    }
  };

  
  // Process AI review data from API
const processAiReviewData = (apiData) => {
  console.log("Raw AI Review Data:", apiData);
    if (!apiData) return null;
    
    // Improved Python dict parser
const parsePythonDict = (dataStr) => {
    if (!dataStr || dataStr.trim() === '{}') return null;
    
    try {
        // Step 1: Clean the string
        let cleanStr = dataStr.trim();
        
        // Remove outer quotes if present
        if ((cleanStr.startsWith('"') && cleanStr.endsWith('"')) || 
            (cleanStr.startsWith("'") && cleanStr.endsWith("'"))) {
            cleanStr = cleanStr.slice(1, -1);
        }
        
        // Step 2: Convert Python-specific syntax to JSON
        let jsonStr = cleanStr
            // Convert Python booleans and None
            .replace(/\bTrue\b/g, 'true')
            .replace(/\bFalse\b/g, 'false')
            .replace(/\bNone\b/g, 'null')
            // Convert single-quoted property names to double-quoted
            .replace(/([{,]\s*)'([^']+)'(\s*:)/g, '$1"$2"$3');
        
        // Step 3: Handle string values carefully
        jsonStr = jsonStr.replace(/(:\s*)'([^']*)'(\s*[,}])/g, (match, p1, p2, p3) => {
            // Escape any double quotes within the string value
            const escapedValue = p2.replace(/"/g, '\\"');
            return `${p1}"${escapedValue}"${p3}`;
        });
        
        // Step 4: Parse the JSON
        return JSON.parse(jsonStr);
        
    } catch (e) {
        console.error('Failed to parse Python dict:', dataStr, e);
        return null;
    }
};
    
    const reviewerData = apiData.ai_review?.[0] || {};
    const subconData = apiData.ai_sub_review?.[0] || {};
    
    // Helper function to process each category
    const processCategory = (data, categoryName) => {
        try {
            const parsed = parsePythonDict(data);
            if (parsed) {
                return {
                    observation: parsed.observation || "No data available",
                    validity: parsed.validity || "no",
                    score: typeof parsed.score === 'number' ? parsed.score : 0
                };
            }
        } catch (e) {
            console.error(`Error processing ${categoryName}:`, e);
        }
        
        return {
            observation: "No data available",
            validity: "no",
            score: 0
        };
    };
    
    return {
        Id: selectedIdea?.Id || transformedData.Id,
        ai_review: [{
            "Strategic Alignment": processCategory(reviewerData["Strategic Alignment"], "Strategic Alignment"),
            "Value & Impact": processCategory(reviewerData["Value & Impact"], "Value & Impact"),
            "Feasibility & Technical Readiness": processCategory(reviewerData["Feasibility & Technical Readiness"], "Feasibility & Technical Readiness"),
            "Risk & Compliance": processCategory(reviewerData["Risk & Compliance"], "Risk & Compliance"),
            "Innovation & Modernization": processCategory(reviewerData["Innovation & Modernization"], "Innovation & Modernization"),
            "Cost Consideration": processCategory(reviewerData["Cost Consideration"], "Cost Consideration"),
            "User & Stakeholder Impact": processCategory(reviewerData["User & Stakeholder Impact"], "User & Stakeholder Impact"),
            "Governance & Oversight Readiness": processCategory(reviewerData["Governance & Oversight Readiness"], "Governance & Oversight Readiness"),
            "Scalability & Reusability": processCategory(reviewerData["Scalability & Reusability"], "Scalability & Reusability"),
            "Dependencies & Constraints": processCategory(reviewerData["Dependencies & Constraints"], "Dependencies & Constraints"),
            "External System Dependencies": processCategory(subconData["External System Dependencies"], "External System Dependencies"),
            "Data Availability and Privacy": processCategory(subconData["Data Availability and Privacy"], "Data Availability and Privacy"),
            "Platform and Infrastructure Constraints": processCategory(subconData["Platform and Infrastructure Constraints"], "Platform and Infrastructure Constraints"),
            "Operational Security Constraints": processCategory(subconData["Operational Security Constraints"], "Operational Security Constraints")
        }]
    };
};
  // Process ITPM AI review data from API
  const processITPMAiReviewData = (apiData) => {
    console.log("Raw ITPM AI Review Data:", apiData);
    if (!apiData) return null;
    
     if (apiData.ai_review?.[0]?.Date) {
    setReviewDate(formatDate(apiData.ai_review[0].Date));
  }
    // Process ITPM data
    const itpmData = apiData.ai_review?.[0] || {};
    
    const result = {
      Id: selectedITPMIdea?.Id || transformedData.Id,
      ai_review: [{}]
    };
    
    // Process each field in the ITPM review data
    Object.entries(itpmData).forEach(([key, value]) => {
      if (key === "Id" || key === "Date") return;
      
      try {
  let parsedValue;

  if (typeof value === 'string') {
    // Use JSON5 to handle sloppy JSON (single quotes, unquoted keys, trailing commas)
    parsedValue = JSON5.parse(value);
  } else {
    parsedValue = value;
  }

  result.ai_review[0][key] = {
    observation: parsedValue?.observation || "No data available",
    validity: parsedValue?.validity || "no",
    score: parsedValue?.score || 0
  };

} catch (e) {
  console.error(`Error parsing ITPM review field ${key}:`, e);
  console.error('Raw value:', value);
  result.ai_review[0][key] = {
    observation: "Error parsing data",
    validity: "no",
    score: 0
  };
}
    });
    
    return result;
  };

  // Fetch AI review data with proper error handling
  const fetchAIReviewData = async (Id) => {
    const ideaId = Id || selectedId || transformedData.Id;
    setLoading(true);
    setError(null);
    try {
      const apiData = await getAIReview(Id);
      const processedData = processAiReviewData(apiData);
      setAiReviewData(processedData);
    } catch (error) {
      console.error("Error fetching review data:", error);
      setError("Failed to load review data.");
      setAiReviewData(null);
    } finally {
      setLoading(false);
    }
  };

  // Fetch ITPM AI review data with proper error handling
  const fetchITPMAIReviewData = async (Id) => {
  const ideaId = Id || selectedId || transformedData.Id;
    setLoading(true);
    setError(null);
    console.log(getITPMAIReview);
    try {
      const apiData = await getITPMAIReview(Id);
      const processedData = processITPMAiReviewData(apiData);
      setITPMAiReviewData(processedData);
    } catch (error) {
      console.error("Error fetching ITPM review data:", error);
      setError("Failed to load ITPM review data.");
      setITPMAiReviewData(null);
    } finally {
      setLoading(false);
    }
  };

  // Load AI review data when tab changes
useEffect(() => {
  if (selectedId) {
    if (activeTab === "ai-review-supervisor") {
      fetchAIReviewData(selectedId);
    } else if (activeTab === "ai-review-itpm") {
      fetchITPMAIReviewData(selectedId);
    } else if (activeTab === "supervisor") {
      fetchSupervisorReviewData(selectedId);
    } else if (activeTab === "itpm") {
      fetchITPMReviewData(selectedId);
    }
  }
}, [selectedId, activeTab]);

  const handleReviewAction = async (action, isITPM = false) => {
    const idea = isITPM ? selectedITPMIdea : selectedIdea;
    const comments = isITPM ? itpmReviewComments : reviewComments;
    
    if (!idea) return;

    setLoading(true);
    try {
      if (action === "approved") {
        if (isITPM) {
          await updateITPMReview(idea.Id, "approved", comments);
        } else {
          await updateSupervisorReview(idea.Id, "approved", comments);
        }
      } else if (action === "reject") {
        if (isITPM) {
          await updateITPMReview(idea.Id, "Rejected", comments);
        } else {
          await updateSupervisorReview(idea.Id, "Rejected", comments);
        }
      } else if (action === "save-draft") {
        await saveDraft(idea.Id, comments);
      } else if (action === "clarify") {
        setShowClarifyBot(true);
        return; // Don't close the modal for clarification
      }

      if (isITPM) {
        setSelectedITPMIdea(null);
        setITPMReviewComments("");
        setITPMAiReviewData(null);
      } else {
        setSelectedIdea(null);
        setReviewComments("");
        setAiReviewData(null);
      }
    } catch (error) {
      console.error("Error updating review:", error);
      setError(`Failed to ${action} review`);
    } finally {
      setLoading(false);
    }
  };

  const getScoreColor = (score) => {
    if (score >= 7) return "text-green-600";
    if (score >= 4) return "text-yellow-600";
    return "text-red-600";
  };

  const getScoreBarColor = (score) => {
    if (score >= 7) return "bg-green-500";
    if (score >= 4) return "bg-yellow-500";
    return "bg-red-500";
  };

  const ReviewModal = React.memo(
    ({
      selectedIdea,
      reviewComments,
      setReviewComments,
      loading,
      error,
      onClose,
      onReviewAction,
      isITPM = false,
      aiReviewData
    }) => {
      const textareaRef = React.useRef(null);

      // Focus the textarea when the modal opens
      React.useEffect(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
      }, []);

return (
  <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-[9998] p-4">
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
      <div className="bg-white border-b border-gray-200 px-6 py-4 rounded-t-xl flex-shrink-0">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold">{selectedIdea?.title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X size={24} />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6">
        

        <div className="mb-6">
          <h3 className="text-lg font-medium text-gray-800 mb-3">
            Review Comments
          </h3>
          <textarea
            ref={textareaRef}
            value={reviewComments}
            onChange={(e) => setReviewComments(e.target.value)}
            placeholder="Add your review comments..."
            className="w-full h-24 p-3 border-2 border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
          />
        </div>

        <div style={{
          display: 'flex',
          gap: '12px',
          paddingTop: '16px',
          borderTop: '1px solid var(--cares-line-card)'
        }}>
          <button
            onClick={() => onReviewAction("approved", isITPM)}
            disabled={loading}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'linear-gradient(135deg, var(--cares-green) 0%, var(--cares-green) 100%)',
              color: 'var(--cares-text-max)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.2s',
              opacity: loading ? 0.6 : 1
            }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-1px)')}
            onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
          >
            <CheckCircle size={18} />
            Accept
          </button>
          <button
            onClick={() => onReviewAction("reject", isITPM)}
            disabled={loading}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'linear-gradient(135deg, var(--cares-orange) 0%, var(--cares-orange) 100%)',
              color: 'var(--cares-text-max)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(239, 68, 68, 0.3)',
              transition: 'all 0.2s',
              opacity: loading ? 0.6 : 1
            }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-1px)')}
            onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
          >
            <XCircle size={18} />
            Reject
          </button>
          <button
            onClick={() => onReviewAction("save-draft", isITPM)}
            disabled={loading}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'linear-gradient(135deg, var(--cares-amber) 0%, var(--cares-amber) 100%)',
              color: 'var(--cares-text-max)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(245, 158, 11, 0.3)',
              transition: 'all 0.2s',
              opacity: loading ? 0.6 : 1
            }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-1px)')}
            onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
          >
            <Save size={18} />
            Save Draft
          </button>
          <button
            onClick={() => onReviewAction("clarify", isITPM)}
            disabled={loading}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '12px 24px',
              background: 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)',
              color: 'var(--cares-text-max)',
              border: 'none',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '600',
              cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: '0 2px 8px rgba(139, 92, 246, 0.3)',
              transition: 'all 0.2s',
              opacity: loading ? 0.6 : 1
            }}
            onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-1px)')}
            onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
          >
            <MessageCircle size={18} />
            Request Clarification
          </button>
        </div>
      </div>
    </div>
  </div>
);
    }
  );

  const ClarifyBotModal = () => {
    const [chatHistory, setChatHistory] = useState([]);
    const [suggestedQuestions, setSuggestedQuestions] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const [loadingChat, setLoadingChat] = useState(false);
    const [currentUser] = useState('Reviewer');
    const CURRENT_ID = selectedId || selectedIdea?.Id

    const fetchChatHistory = async () => {
      try {
        setLoadingChat(true);
        const response = await fetch(`/api/chat/getchathistory?Id=${CURRENT_ID}`);
        const data = await response.json();

        if (data.chat) {
          setChatHistory(data.chat);
        }
        if (data.suggested_questions) {
          setSuggestedQuestions(data.suggested_questions);
        }
      } catch (error) {
        console.error('Error fetching chat history:', error);
      } finally {
        setLoadingChat(false);
      }
    };

const addChatMessage = async (message, role = currentUser) => {
  try {
    // Create query parameters instead of body parameters
    const queryParams = new URLSearchParams({
      Id: CURRENT_ID,
      Role: role,
      ChatInfo: message,
    });

    const response = await fetch(`/api/chat/addchat?${queryParams}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Changed from form data
      },
      // Remove body since we're using query parameters
    });

    const data = await response.json();

    if (response.ok) {
      await fetchChatHistory();
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error adding chat message:', error);
    return false;
  }
};

    const handleSendMessage = async (e) => {
      if (!newMessage.trim()) return;

      setLoadingChat(true);
      const success = await addChatMessage(newMessage);

      if (success) {
        setNewMessage('');
      }
      setLoadingChat(false);
    };

    const handleSuggestedQuestion = async (question) => {
      setLoadingChat(true);
      const success = await addChatMessage(question);
      setLoadingChat(false);
    };

    const formatTimestamp = (timestamp) => {
  try {
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch {
    return timestamp;
  }
};

    const getRoleColor = (role) => {
      switch (role?.toLowerCase()) {
        case 'reviewer':
          return 'bg-red-100 border-red-200 text-red-800';
        case 'submitter':
          return 'bg-green-100 border-green-200 text-green-800';
        case 'admin':
          return 'bg-blue-100 border-blue-200 text-blue-800';
        default:
          return 'bg-gray-100 border-gray-200 text-gray-800';
      }
    };

    const getRoleIcon = (role) => {
      switch (role?.toLowerCase()) {
        case 'reviewer':
          return <Users className="w-4 h-4" />;
        case 'submitter':
          return <MessageCircle className="w-4 h-4" />;
        case 'admin':
          return <Brain className="w-4 h-4" />;
        default:
          return <Users className="w-4 h-4" />;
      }
    };

    useEffect(() => {
      if (showClarifyBot) {
        fetchChatHistory();
      }
    }, [showClarifyBot]);

    // Don't render if not visible
    if (!showClarifyBot) return null;

return (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
    <div className="relative w-full max-w-6xl max-h-[90vh] bg-white rounded-xl shadow-2xl overflow-hidden flex flex-col animate-in fade-in duration-200">
      {/* Modal header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 flex-shrink-0">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">ClarifyBot - Clarification Request</h2>
          <button
            onClick={() => setShowClarifyBot(false)}
            className="text-gray-500 hover:text-gray-700 p-1 rounded-full hover:bg-gray-100 transition-colors"
          >
            <X size={24} />
          </button>
        </div>
      </div>

      {/* Modal content */}
      <div className="flex-1 overflow-hidden flex min-h-0">
        {/* Main Chat Area */}
        <div className="flex-1 flex flex-col overflow-hidden min-w-0">
          {/* Chat Messages */}
          <div className="flex-1 overflow-y-auto p-6 space-y-4">
            {loadingChat && chatHistory.length === 0 ? (
              <div className="flex items-center justify-center h-64">
                <div className="text-gray-500">Loading chat history...</div>
              </div>
            ) : chatHistory.length === 0 ? (
              <div className="flex flex-col items-center justify-center h-64 text-center">
                <MessageCircle className="w-16 h-16 text-gray-300 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">No active clarification threads</h3>
                <p className="text-gray-500">Create a new clarification request to get started</p>
              </div>
            ) : (
              chatHistory.map((message, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${getRoleColor(message.Role)}`}>
                    {getRoleIcon(message.Role)}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2">
                      <span className="text-sm font-medium text-gray-900">{message.Role}</span>
                      <span className="text-xs text-gray-500 flex items-center">
                        <Clock className="w-3 h-3 mr-1" />
                        {formatTimestamp(message.Timestamp)}
                      </span>
                    </div>
                    <div className={`mt-1 p-3 rounded-lg border ${getRoleColor(message.Role)}`}>
                      <p className="text-sm">{message['Chat Info']}</p>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Message Input */}
          <div className="bg-white border-t border-gray-200 p-6 flex-shrink-0">
            <div className="flex space-x-4">
              <div className="flex-1">
                <input
                  type="text"
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  placeholder="Type your clarification request..."
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  disabled={loadingChat}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage(e);
                    }
                  }}
                />
              </div>
              <button
                onClick={handleSendMessage}
                disabled={!newMessage.trim() || loadingChat}
                className="px-6 py-2 bg-gray-52 text-black rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
              >
                <span>{loadingChat ? 'Sending...' : 'Send'}</span>
              </button>
            </div>
          </div>
        </div>

        {/* Suggested Questions Sidebar */}
        <div className="w-80 bg-gray-50 border-l border-gray-200 overflow-y-auto flex-shrink-0">
          <div className="p-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Suggested Questions</h3>

            <div className="space-y-3">
              <div
                className="p-4 bg-white rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200"
                onClick={() => handleSuggestedQuestion("What is the expected budget range for this initiative?")}
              >
                <p className="text-sm text-gray-900 mb-1">What is the expected budget range for this initiative?</p>
                <p className="text-xs text-gray-500">• Commonly asked • High relevance</p>
              </div>

              <div
                className="p-4 bg-white rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200"
                onClick={() => handleSuggestedQuestion("Are there any technical dependencies we should be aware of?")}
              >
                <p className="text-sm text-gray-900 mb-1">Are there any technical dependencies we should be aware of?</p>
                <p className="text-xs text-gray-500">• Commonly asked • High relevance</p>
              </div>

              <div
                className="p-4 bg-white rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200"
                onClick={() => handleSuggestedQuestion("Who are the key stakeholders for this project?")}
              >
                <p className="text-sm text-gray-900 mb-1">Who are the key stakeholders for this project?</p>
                <p className="text-xs text-gray-500">• Based on similar ideas</p>
              </div>

              <div
                className="p-4 bg-white rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200"
                onClick={() => handleSuggestedQuestion("What is the expected timeline for implementation?")}
              >
                <p className="text-sm text-gray-900 mb-1">What is the expected timeline for implementation?</p>
                <p className="text-xs text-gray-500">• Based on similar ideas</p>
              </div>

              <div
                className="p-4 bg-white rounded-lg hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200"
                onClick={() => handleSuggestedQuestion("Have you considered any alternative solutions?")}
              >
                <p className="text-sm text-gray-900 mb-1">Have you considered any alternative solutions?</p>
                <p className="text-xs text-gray-500">• Governance requirement</p>
              </div>
            </div>

            {suggestedQuestions.length > 0 && (
              <>
                <h4 className="text-md font-medium text-gray-900 mt-6 mb-3">AI Suggested Questions</h4>
                <div className="space-y-3">
                  {suggestedQuestions.map((question, index) => (
                    <div
                      key={index}
                      className="p-4 bg-blue-50 rounded-lg hover:bg-blue-100 cursor-pointer transition-colors border border-blue-200"
                      onClick={() => handleSuggestedQuestion(question)}
                    >
                      <p className="text-sm text-gray-900">{question}</p>
                      <p className="text-xs text-blue-600 mt-1">• AI Generated</p>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
);
  };

  const renderAiReviewItem = (key, value) => {
    if (key === "Id" || key === "Date" || key === "Review Date") return null;

    let reviewData;

    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      reviewData = value;
    } else if (
      typeof value === "string" &&
      value.trim().startsWith("{") &&
      value.trim().endsWith("}")
    ) {
      try {
        try {
          reviewData = JSON.parse(value);
        } catch (e) {
          const jsonString = value
            .replace(/'/g, '"')
            .replace(/(\w+):/g, '"$1":');
          reviewData = JSON.parse(jsonString);
        }
      } catch (e) {
        console.error(`Failed to parse review data for ${key}:`, value);
        return null;
      }
    } else {
      return null;
    }

    if (!reviewData || typeof reviewData.score === "undefined") {
      return null;
    }

    return (
      <div key={key} className="bg-white rounded-lg p-4 shadow-sm">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-medium text-gray-800 text-sm">{key}</h4>
          <span className={`font-bold ${getScoreColor(reviewData.score)}`}>
            {reviewData.score}/10
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
          <div
            className={`h-2 rounded-full ${getScoreBarColor(reviewData.score)}`}
            style={{ width: `${reviewData.score * 10}%` }}
          ></div>
        </div>
        <p className="text-xs text-gray-600 leading-relaxed">
          {reviewData.observation || "No observation available"}
        </p>
        {reviewData.validity && (
          <div className="mt-2">
            <span
              className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${
                reviewData.validity === "yes"
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {reviewData.validity === "yes" ? "Valid" : "Needs Attention"}
            </span>
          </div>
        )}
      </div>
    );
  };

return (
  <div style={{ minHeight: '100vh', background: 'var(--cares-surface-board)' }}>
    <div style={{ padding: '24px' }}>
      {/* Professional Header with Breadcrumbs */}
      <IdeasPageHeader
        title="Review Process Dashboard"
        description="Comprehensive AI-powered idea analysis and evaluation workflow"
        breadcrumbPath="Review Process"
      />

    {/* Idea Selector Section */}
    <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '24px 32px' }}>
      <div style={{
        background: 'var(--cares-surface-card)',
        borderRadius: '12px',
        padding: '20px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        marginBottom: '24px'
      }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: 'var(--cares-text-3)',
          marginBottom: '8px'
        }}>
          Select Idea to Review
        </label>
        <select
          value={selectedId || ''}
          onChange={(e) => {
            setSelectedIdeaId(e.target.value);
            setSelectedIdea(null);
            setSelectedITPMIdea(null);
            setReviewComments("");
            setITPMReviewComments("");
          }}
          style={{
            width: '100%',
            padding: '12px 16px',
            background: 'var(--cares-surface-card)',
            border: '2px solid var(--cares-line-card)',
            borderRadius: '8px',
            fontSize: '15px',
            color: 'var(--cares-text-2)',
            cursor: 'pointer',
            outline: 'none',
            transition: 'all 0.2s'
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--cares-purple)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--cares-line-card)'}
        >
          <option value="">Select an idea to review...</option>
          {pendingIds.map((item) => (
            <option key={item.id} value={item.id}>
              {item.id} - {item.title}
            </option>
          ))}
        </select>
      </div>

      {/* Professional Tabs */}
      <div style={{
        background: 'var(--cares-surface-card)',
        borderRadius: '12px',
        padding: '8px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        marginBottom: '24px',
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap'
      }}>
        {[
          { id: "ai-review-supervisor", icon: Brain, label: "AI Supervisor Review" },
          { id: "supervisor", icon: Users, label: "Supervisor Review" },
          { id: "ai-review-itpm", icon: Brain, label: "AI ITPM Review" },
          { id: "itpm", icon: BarChart3, label: "ITPM Review" },
          { id: "analytics", icon: TrendingUp, label: "Analytics" }
        ].map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '12px 16px',
                borderRadius: '8px',
                border: 'none',
                background: isActive ? 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)' : 'transparent',
                color: isActive ? 'var(--cares-text-max)' : 'var(--cares-text-label)',
                fontWeight: isActive ? '600' : '500',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.2s',
                boxShadow: isActive ? '0 4px 6px rgba(102, 126, 234, 0.3)' : 'none'
              }}
              onMouseEnter={(e) => {
                if (!isActive) {
                  e.target.style.background = 'var(--cares-surface-board)';
                }
              }}
              onMouseLeave={(e) => {
                if (!isActive) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              <Icon size={18} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </div>

        {/* Content Sections */}
        {activeTab === "supervisor" && (
          <div style={{ animation: 'fadeIn 0.3s ease-in' }}>
            <div style={{ marginBottom: '32px', textAlign: 'center' }}>
              <h2 style={{
                fontSize: '28px',
                fontWeight: 'bold',
                color: 'var(--cares-text-2)',
                marginBottom: '8px'
              }}>
                Supervisor Review
              </h2>
              <p style={{
                fontSize: '16px',
                color: 'var(--cares-text-label)',
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                First-level review for submitted ideas. Assess feasibility and alignment with organizational goals.
              </p>
            </div>

            {supervisorReviewData ? (
              <div style={{
                background: 'var(--cares-surface-card)',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                border: '1px solid var(--cares-line-card)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #f0f4ff 0%, color-mix(in srgb, var(--cares-purple) 22%, var(--cares-surface-card)) 100%)',
                  padding: '24px',
                  borderBottom: '1px solid var(--cares-line-card)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                        <h3 style={{
                          fontSize: '22px',
                          fontWeight: '600',
                          color: 'var(--cares-text-2)'
                        }}>
                          {selectedId}: {supervisorReviewData.title || "No title available"}
                        </h3>
                        <span style={{
                          padding: '6px 12px',
                          fontSize: '13px',
                          fontWeight: '600',
                          borderRadius: '20px',
                          background: supervisorReviewData.priority === "high" ? 'color-mix(in srgb, var(--cares-orange) 22%, var(--cares-surface-card))' : 'color-mix(in srgb, var(--cares-amber) 22%, var(--cares-surface-card))',
                          color: supervisorReviewData.priority === "high" ? 'var(--cares-orange)' : 'var(--cares-amber)'
                        }}>
                          {supervisorReviewData.priority || "unknown"} priority
                        </span>
                      </div>
                      <p style={{ fontSize: '14px', color: 'var(--cares-text-label)' }}>
                        <span style={{ fontWeight: '500' }}>Submitted by</span> {supervisorReviewData.submitter || "Unknown"} • {reviewDate}
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '24px' }}>
                    <h4 style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--cares-text-2)',
                      marginBottom: '12px'
                    }}>
                      Description
                    </h4>
                    <p style={{
                      color: 'var(--cares-text-3)',
                      fontSize: '15px',
                      lineHeight: '1.6',
                      background: 'var(--cares-surface-board)',
                      padding: '16px',
                      borderRadius: '8px'
                    }}>
                      {supervisorReviewData.description || "No description available"}
                    </p>
                  </div>

                  {supervisorReviewData.businessCase && (
                    <div style={{ marginBottom: '24px' }}>
                      <h4 style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: 'var(--cares-text-2)',
                        marginBottom: '12px'
                      }}>
                        Business Case
                      </h4>
                      <p style={{
                        color: 'var(--cares-text-3)',
                        fontSize: '15px',
                        lineHeight: '1.6',
                        background: 'var(--cares-surface-board)',
                        padding: '16px',
                        borderRadius: '8px'
                      }}>
                        {supervisorReviewData.businessCase}
                      </p>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px'
                  }}>
                    <button
                      onClick={() => setSelectedIdea(supervisorReviewData)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      Review This Idea
                    </button>
                    <button
                      onClick={() => fetchQuestionResponses(selectedId)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-blue) 0%, var(--cares-blue) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      View Submitted Questions
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
                <div className="animate-pulse flex flex-col items-center justify-center py-12">
                  <div className="w-12 h-12 bg-blue-100 rounded-full mb-4"></div>
                  <div className="h-4 bg-blue-100 rounded w-3/4 max-w-md mb-2"></div>
                  <div className="h-4 bg-blue-100 rounded w-1/2 max-w-xs"></div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "itpm" && (
          <div style={{ animation: 'fadeIn 0.3s ease-in' }}>
            <div style={{ marginBottom: '32px', textAlign: 'center' }}>
              <h2 style={{
                fontSize: '28px',
                fontWeight: 'bold',
                color: 'var(--cares-text-2)',
                marginBottom: '8px'
              }}>
                ITPM Review
              </h2>
              <p style={{
                fontSize: '16px',
                color: 'var(--cares-text-label)',
                maxWidth: '600px',
                margin: '0 auto'
              }}>
                Technical and portfolio management review for submitted ideas.
              </p>
            </div>

            {itpmReviewData ? (
              <div style={{
                background: 'var(--cares-surface-card)',
                borderRadius: '16px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                border: '1px solid var(--cares-line-card)'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #f0f4ff 0%, color-mix(in srgb, var(--cares-purple) 22%, var(--cares-surface-card)) 100%)',
                  padding: '24px',
                  borderBottom: '1px solid var(--cares-line-card)'
                }}>
                  <div style={{ display: 'flex', alignItems: 'start', justifyContent: 'space-between' }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                        <h3 style={{
                          fontSize: '22px',
                          fontWeight: '600',
                          color: 'var(--cares-text-2)'
                        }}>
                          {selectedId}: {itpmReviewData.title || "No title available"}
                        </h3>
                        <span style={{
                          padding: '6px 12px',
                          fontSize: '13px',
                          fontWeight: '600',
                          borderRadius: '20px',
                          background: itpmReviewData.priority === "high" ? 'color-mix(in srgb, var(--cares-orange) 22%, var(--cares-surface-card))' : 'color-mix(in srgb, var(--cares-amber) 22%, var(--cares-surface-card))',
                          color: itpmReviewData.priority === "high" ? 'var(--cares-orange)' : 'var(--cares-amber)'
                        }}>
                          {itpmReviewData.priority || "unknown"} priority
                        </span>
                      </div>
                      <p style={{ fontSize: '14px', color: 'var(--cares-text-label)' }}>
                        <span style={{ fontWeight: '500' }}>Submitted by</span> {itpmReviewData.submitter || "Unknown"} • {reviewDate}
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '24px' }}>
                    <h4 style={{
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--cares-text-2)',
                      marginBottom: '12px'
                    }}>
                      Description
                    </h4>
                    <p style={{
                      color: 'var(--cares-text-3)',
                      fontSize: '15px',
                      lineHeight: '1.6',
                      background: 'var(--cares-surface-board)',
                      padding: '16px',
                      borderRadius: '8px'
                    }}>
                      {itpmReviewData.description || "No description available"}
                    </p>
                  </div>

                  {itpmReviewData.businessCase && (
                    <div style={{ marginBottom: '24px' }}>
                      <h4 style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: 'var(--cares-text-2)',
                        marginBottom: '12px'
                      }}>
                        Business Case
                      </h4>
                      <p style={{
                        color: 'var(--cares-text-3)',
                        fontSize: '15px',
                        lineHeight: '1.6',
                        background: 'var(--cares-surface-board)',
                        padding: '16px',
                        borderRadius: '8px'
                      }}>
                        {itpmReviewData.businessCase}
                      </p>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px'
                  }}>
                    <button
                      onClick={() => setSelectedITPMIdea(itpmReviewData)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      Review This Idea
                    </button>
                    <button
                      onClick={() => fetchQuestionResponses(selectedId)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-blue) 0%, var(--cares-blue) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      View Submitted Questions
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
                <div className="animate-pulse flex flex-col items-center justify-center py-12">
                  <div className="w-12 h-12 bg-blue-100 rounded-full mb-4"></div>
                  <div className="h-4 bg-blue-100 rounded w-3/4 max-w-md mb-2"></div>
                  <div className="h-4 bg-blue-100 rounded w-1/2 max-w-xs"></div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "analytics" && (
          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="max-w-md mx-auto">
              <BarChart3 size={48} className="mx-auto text-blue-500 mb-4" />
              <h2 className="text-2xl font-bold text-gray-800 mb-2">Review Analytics</h2>
              <p className="text-gray-600 mb-6">Detailed analytics dashboard coming soon with comprehensive metrics and insights.</p>
              <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl p-6 border border-gray-200">
                <p className="text-sm text-gray-600">Check back later for interactive charts and performance metrics.</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === "ai-review-supervisor" && (
          <div className="animate-fade-in">
            <div className="mb-8 text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-2 flex">
                AI Supervisor Analysis <span className="text-blue-600"></span>
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto flex">
                AI-powered assessment of strategic alignment and business impact.
              </p>
            </div>

            {supervisorReviewData ? (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-1">
                        <h3 className="text-xl font-semibold text-black flex items-center gap-2">
                          <Brain className="text-black" size={20} />
                          {selectedId}: {supervisorReviewData.title}
                        </h3>
                        <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                          supervisorReviewData.priority === "high" 
                            ? "bg-red-100 text-red-700" 
                            : "bg-yellow-100 text-yellow-700"
                        }`}>
                          {supervisorReviewData.priority}
                        </span>
                      </div>
                      <p className="text-sm text-blue-100">
  Submitted by {supervisorReviewData.submitter} • {reviewDate}
</p>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="mb-6 bg-blue-50 rounded-xl p-4 border border-blue-100">
                    <h4 className="text-lg font-medium text-gray-800 mb-2">Description</h4>
                    <p className="text-gray-700 leading-relaxed">
                      {supervisorReviewData.description}
                    </p>
                  </div>

                  {loading ? (
                    <div className="flex justify-center items-center py-12">
                      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
                    </div>
                  ) : aiReviewData ? (
                    <div className="mb-6">
                      <div className="flex items-center justify-between mb-6">
                        <h4 className="text-xl font-semibold text-gray-800">
                          AI Analysis Results
                        </h4>
                        <div className="flex items-center gap-2 bg-green-50 px-3 py-1 rounded-full">
                          <span className="text-green-700 text-sm font-medium">AI Confidence: 92%</span>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {aiReviewData.ai_review && aiReviewData.ai_review[0] ? (
                          Object.entries(aiReviewData.ai_review[0]).map(
                            ([key, value]) => renderAiReviewItem(key, value)
                          )
                        ) : (
                          <div className="col-span-2 text-center py-8 text-gray-500">
                            No AI review data available
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-12 bg-gray-50 rounded-xl">
                      <Brain size={48} className="mx-auto text-gray-400 mb-4" />
                      <h4 className="text-lg font-medium text-gray-700 mb-2">No AI Analysis Available</h4>
                      <p className="text-gray-500">The AI review for this idea hasn't been generated yet.</p>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px'
                  }}>
                    <button
                      onClick={() => setSelectedIdea(supervisorReviewData)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      Review This Idea
                    </button>
                    <button
                      onClick={() => fetchQuestionResponses(selectedId)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-blue) 0%, var(--cares-blue) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      View Submitted Questions
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
                <div className="animate-pulse flex flex-col items-center justify-center py-12">
                  <div className="w-12 h-12 bg-blue-100 rounded-full mb-4"></div>
                  <div className="h-4 bg-blue-100 rounded w-3/4 max-w-md mb-2"></div>
                  <div className="h-4 bg-blue-100 rounded w-1/2 max-w-xs"></div>
                </div>
              </div>
            )}
          </div>
        )}

        {activeTab === "ai-review-itpm" && (
          <div className="animate-fade-in">
            <div className="mb-8 text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-2 flex">
                AI ITPM Analysis <span className="text-blue-600"></span>
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto flex">
                AI-powered technical and portfolio management assessment.
              </p>
            </div>

            {itpmReviewData ? (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-blue-800 px-6 py-4">
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-3 mb-1">
                        <h3 className="text-xl font-semibold text-black flex items-center gap-2">
                          <Brain className="text-black" size={20} />
                          {selectedId}: {itpmReviewData.title}
                        </h3>
                        <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                          itpmReviewData.priority === "high" 
                            ? "bg-red-100 text-red-700" 
                            : "bg-yellow-100 text-yellow-700"
                        }`}>
                          {itpmReviewData.priority}
                        </span>
                      </div>
                      <p className="text-sm text-blue-100">
  Submitted by {itpmReviewData.submitter} • {reviewDate}
</p>
                    </div>
                  </div>
                </div>

                <div className="p-6">
                  <div className="mb-6 bg-blue-50 rounded-xl p-4 border border-blue-100">
                    <h4 className="text-lg font-medium text-gray-800 mb-2">Description</h4>
                    <p className="text-gray-700 leading-relaxed">
                      {itpmReviewData.description}
                    </p>
                  </div>

                  {loading ? (
                    <div className="flex justify-center items-center py-12">
                      <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-blue-500"></div>
                    </div>
                  ) : itpmAiReviewData ? (
                    <div className="mb-6">
                      <div className="flex items-center justify-between mb-6">
                        <h4 className="text-xl font-semibold text-gray-800">
                          ITPM AI Analysis Results
                        </h4>
                        <div className="flex items-center gap-2 bg-green-50 px-3 py-1 rounded-full">
                          <span className="text-green-700 text-sm font-medium">AI Confidence: 89%</span>
                        </div>
                      </div>
                      
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {itpmAiReviewData.ai_review && itpmAiReviewData.ai_review[0] ? (
                          Object.entries(itpmAiReviewData.ai_review[0]).map(
                            ([key, value]) => renderAiReviewItem(key, value)
                          )
                        ) : (
                          <div className="col-span-2 text-center py-8 text-gray-500">
                            No ITPM AI review data available
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="text-center py-12 bg-gray-50 rounded-xl">
                      <Brain size={48} className="mx-auto text-gray-400 mb-4" />
                      <h4 className="text-lg font-medium text-gray-700 mb-2">No ITPM Analysis Available</h4>
                      <p className="text-gray-500">The ITPM AI review for this idea hasn't been generated yet.</p>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px'
                  }}>
                    <button
                      onClick={() => setSelectedITPMIdea(itpmReviewData)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-purple) 0%, var(--cares-purple) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      Review This Idea
                    </button>
                    <button
                      onClick={() => fetchQuestionResponses(selectedId)}
                      disabled={loading}
                      style={{
                        padding: '14px 32px',
                        background: 'linear-gradient(135deg, var(--cares-blue) 0%, var(--cares-blue) 100%)',
                        color: 'var(--cares-text-max)',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '15px',
                        fontWeight: '600',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)',
                        transition: 'all 0.2s',
                        opacity: loading ? 0.6 : 1
                      }}
                      onMouseEnter={(e) => !loading && (e.target.style.transform = 'translateY(-2px)')}
                      onMouseLeave={(e) => !loading && (e.target.style.transform = 'translateY(0)')}
                    >
                      View Submitted Questions
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 text-center">
                <div className="animate-pulse flex flex-col items-center justify-center py-12">
                  <div className="w-12 h-12 bg-blue-100 rounded-full mb-4"></div>
                  <div className="h-4 bg-blue-100 rounded w-3/4 max-w-md mb-2"></div>
                  <div className="h-4 bg-blue-100 rounded w-1/2 max-w-xs"></div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Review Modal - Enhanced */}
      {selectedIdea && (
        <ReviewModal
          selectedIdea={selectedIdea}
          reviewComments={reviewComments}
          setReviewComments={setReviewComments}
          loading={loading}
          error={error}
          onClose={() => {
            setSelectedIdea(null);
            setAiReviewData(null);
          }}
          onReviewAction={handleReviewAction}
          aiReviewData={aiReviewData}
        />
      )}

      {/* ITPM Review Modal - Enhanced */}
      {selectedITPMIdea && (
        <ReviewModal
          selectedIdea={selectedITPMIdea}
          reviewComments={itpmReviewComments}
          setReviewComments={setITPMReviewComments}
          loading={loading}
          error={error}
          onClose={() => {
            setSelectedITPMIdea(null);
            setITPMAiReviewData(null);
          }}
          onReviewAction={handleReviewAction}
          isITPM={true}
          aiReviewData={itpmAiReviewData}
        />
      )}

      {/* ClarifyBot Modal */}
      {showClarifyBot && <ClarifyBotModal />}

      {showQuestionsModal && (
  <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
    <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
      <div className="bg-gradient-to-r from-purple-600 to-blue-600 px-6 py-4 rounded-t-xl flex-shrink-0">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-white">Submitted Questions & Responses</h2>
          <button
            onClick={() => {
              setShowQuestionsModal(false);
              setQuestionResponses(null);
            }}
            className="text-white hover:text-gray-200 p-1 rounded-full hover:bg-black/10 transition-colors"
          >
            <X size={24} />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-6">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
          </div>
        ) : questionResponses ? (
          <div className="space-y-6">
            {Object.entries(questionResponses).map(([question, response], index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                <div className="flex items-start mb-3">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center mr-3">
                    <span className="text-purple-600 font-bold">Q</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900">{question}</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mr-3">
                    <span className="text-blue-600 font-bold">A</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-gray-700">{response || "No response provided"}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-64 text-center">
            <MessageCircle className="w-16 h-16 text-gray-300 mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No questions found</h3>
            <p className="text-gray-500">No questions have been submitted for this idea</p>
          </div>
        )}
      </div>
    </div>
  </div>
)}
      </div>
    </div>
  );
};

export default ReviewProcessComponent;